import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";

const buttonStyles = css`
  & {
    padding: 10px 15px;
    font-size: 18px;
    background: transparent;
    outline: none;
    cursor: pointer;
    transition: 300ms;
    color: ${(props) => props.theme.primary};
    border: 2px solid;
    box-shadow: 0 0 5px;
  }

  &:hover,
  &:focus {
    color: ${(props) => props.theme.primaryFont};
    border: 2px solid ${(props) => props.theme.primary};
    background: ${(props) => props.theme.primary};
    box-shadow: 0 0 20px ${(props) => props.theme.primary};
  }
`;

export const BtnStyled = styled.button`
  ${buttonStyles}
`;

// @ts-ignore
export const NavLinkStyled = styled(NavLink)`
${buttonStyles}
`;
